import Vue from 'vue'
import App from '@/App.vue'
import router from '@/router'
import store from '@/store'

// element
import ElementUI from 'element-ui'
// import 'element-ui/lib/theme-chalk/index.css'
import 'assets/element-#374978/index.css'
Vue.use(ElementUI, { size: 'mini' })


import i18n from './i18n'
import locale from 'element-ui/lib/locale/lang/en'
Vue.use(ElementUI, { locale })

import VueGtag from 'vue-gtag'
Vue.use(VueGtag, {
  config: { id: 'UA-86445773-3' }
})

// 原型上挂载数据和方法
import API from '@/request/api'
Vue.prototype.$api = API

// 原型上挂载数据和方法
import tool from '@/utils/index.js'
Vue.prototype.$tool = tool

// 全局混入
import mixin_base from '@/mixins/mixin_base'
Vue.mixin(mixin_base)


// 全局引入自定义组件
import my_components from '@/components/index.js'
Vue.use(my_components)

import { isOperateFun, stopOperateFun } from '@/utils/timingLock'

router.beforeEach((to, from, next) => {
  // const ROUTE = to.name 
  // console.log(`%croute:`, 'color: #ff0;', ROUTE)
  // —————————————————————————————————— 判断当前使用的客户端  ——————————————————————————————————↓
  // const LIST_ALL = [
  //   'officialWebHome',
  //   'officialWebContact',
  //   'officialWebRecruit',
  //   'officialWebRecruitDetail',
  //   'officialWebArticle',
  //   'mofficialWebHome',
  //   'mofficialWebContact',
  //   'mofficialWebRecruit',
  //   'mofficialWebRecruitDetail',
  //   'mofficialWebArticle',
  // ]
  // const LIST_PC = [
  //   'officialWebHome',
  //   'officialWebContact',
  //   'officialWebRecruit',
  //   'officialWebRecruitDetail',
  //   'officialWebArticle',
  // ]
  // const LIST_MOBILE = [
  //   'mofficialWebHome',
  //   'mofficialWebContact',
  //   'mofficialWebRecruit',
  //   'mofficialWebRecruitDetail',
  //   'mofficialWebArticle',
  // ]
  // if (LIST_ALL.includes(ROUTE)) {
  //   if (/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
  //     ROUTE.indexOf('m') ? router.push(`/m${ROUTE}`) : ''
  //   } else if (!ROUTE.indexOf('m')) {
  //     router.push(ROUTE.substr(1))
  //   }
  // }
  // —————————————————————————————————— 判断当前使用的客户端  ——————————————————————————————————↑
  
  // —————————————————————————————————— 官网切换路由后回到顶部 ——————————————————————————————————↓
  // if (LIST_ALL.includes(ROUTE)) {
  //   document.documentElement.scrollTop = 0
  // }
  // —————————————————————————————————— 官网切换路由后回到顶部 ——————————————————————————————————↑

  // —————————————————————————————————— 判断登陆状态 ——————————————————————————————————↓
  const HAS_LOGIN = JSON.parse(sessionStorage.getItem('dola_user')) ? true : false
  // console.log(to.name)
  if (to.meta.isRequireLogin) {
    if (HAS_LOGIN === false){
      // console.log('%crequire login but not login', 'color:red')
      next('/login')
    } else {
      // console.log('%chas login', 'color:red')
      next()
    }
  } else if (from.path == '/'){
    // console.log('%cis root', 'color:red')
    next()
  } else {
    // console.log('%cother', 'color:red')
    next()
  }
  // —————————————————————————————————— 判断登陆状态 ——————————————————————————————————↑

  if (['login', 'lock', 'clock'].includes(to.name)) {
    stopOperateFun()
  } else {
    if (store.state.company_x && store.state.company_x.enableEmployeeModule) {
      if (store.state.shop_x && store.state.shop_x.shopConfig) {
        // const { enableScreeAutoLock, screeAutoLockTime } = store.state.shop_x.shopConfig
        // console.log(`%c是否开启锁屏:`, 'color: #00f;', enableScreeAutoLock, screeAutoLockTime)
        // if (enableScreeAutoLock) {
        //   isOperateFun(screeAutoLockTime || 30)
        //   // isOperateFun(500000)
        // }
        const { screeAutoLockTime } = store.state.shop_x.shopConfig
        console.log(`%c是否开启锁屏:`, 'color: #00f;', screeAutoLockTime)
        isOperateFun(screeAutoLockTime || 60)
      }
    }
  }
})

Vue.config.productionTip = false

export default new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
